export class ContinueReading {
    continueReadingButton: HTMLElement | null = document.querySelector('a[href="#continueReading"]');

    constructor() {
        if (!this.continueReadingButton) {
            return;
        }

        this.continueReadingButton.addEventListener('click', (e: Event) => {
            e.preventDefault();

            const buttonWrapper = this.continueReadingButton?.parentElement;
            const contentFields = buttonWrapper?.parentElement?.querySelectorAll('.hidden[data-content-field]');

            if (!contentFields) {
                return;
            }

            contentFields.forEach((contentField) => {
                (contentField as HTMLElement).classList.remove('hidden');
            });

            buttonWrapper?.classList.add('!hidden');
        });
    }
}